import * as React from 'react';

import { Button } from '@rematter/ui-web';
import { CheckCircle } from 'lucide-react';
import { useLocation } from 'wouter';

import { useTranslations } from '~/shared/i18n/useTranslations';

type SuccessAnimationProps = {
  message?: string;
};

export const SuccessAnimation = ({ message }: SuccessAnimationProps) => {
  const t = useTranslations();
  const [, setLocation] = useLocation();

  const handleContinue = () => {
    setLocation('/sign-in');
  };

  return (
    <div className="@SuccessAnimation flex flex-col items-center justify-center gap-6 py-8">
      <div className="relative">
        <div className="flex h-24 w-24 items-center justify-center rounded-full bg-success/10">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-success/20">
            <CheckCircle className="h-10 w-10 text-success" />
          </div>
        </div>
      </div>

      <div className="text-center">
        <h2 className="text-xl font-semibold text-foreground">
          {message ?? t.auth.signUpSuccess.defaultMessage}
        </h2>
        <p className="mt-2 text-sm text-neutral">
          {t.auth.signUpSuccess.canSignIn}
        </p>
      </div>

      <Button
        variant="solid"
        color="primary"
        onPress={handleContinue}
        className="w-full"
      >
        {t.auth.signUpSuccess.continueToSignIn}
      </Button>
    </div>
  );
};
